import { getDbSupabase } from './supabase';
import type { PostgrestError } from '@supabase/supabase-js';

/** Persist logo path on the account row (REST update, then RPC fallback). */
export async function saveClientLogoPath(
  clientId: string,
  logoPath: string,
): Promise<{ error: PostgrestError | null; usedRpc: boolean }> {
  const { error: updateError } = await getDbSupabase()
    .from('clients')
    .update({ logo_path: logoPath })
    .eq('id', clientId);

  if (!updateError) {
    return { error: null, usedRpc: false };
  }

  const msg = updateError.message ?? '';
  const schemaStale =
    updateError.code === 'PGRST204' ||
    /schema cache|schema is out of sync|out of sync|logo_path/i.test(msg);

  if (!schemaStale) {
    return { error: updateError, usedRpc: false };
  }

  const { error: rpcError } = await getDbSupabase().rpc('crm_set_client_logo_path', {
    p_client_id: String(clientId),
    p_logo_path: logoPath,
  });

  if (rpcError) {
    return { error: rpcError as PostgrestError, usedRpc: true };
  }

  return { error: null, usedRpc: true };
}
